// Custom cursor
const cursor = document.getElementById('cursor');
const ring = document.getElementById('cursorRing');
if(cursor && ring){
  let mx=0,my=0,rx=0,ry=0;
  document.addEventListener('mousemove',e=>{
    mx=e.clientX; my=e.clientY;
    cursor.style.transform=`translate(${mx-5}px,${my-5}px)`;
  });
  function animRing(){
    rx+=(mx-rx)*0.12; ry+=(my-ry)*0.12;
    ring.style.transform=`translate(${rx-16}px,${ry-16}px)`;
    requestAnimationFrame(animRing);
  }
  animRing();
}

// Navbar scroll shadow
window.addEventListener('scroll',()=>{
  const nav = document.getElementById('navbar');
  if(nav) nav.classList.toggle('scrolled', window.scrollY > 40);
});

// Fabric nav active tab
document.querySelectorAll('.fabric-btn').forEach(btn=>{
  btn.addEventListener('click',function(){
    document.querySelectorAll('.fabric-btn').forEach(b=>b.classList.remove('active'));
    this.classList.add('active');
  });
});

// Wishlist heart toggle
document.querySelectorAll('.cc-wish').forEach(w=>{
  w.addEventListener('click',function(e){
    e.stopPropagation();
    this.textContent = this.textContent==='♡'?'♥':'♡';
    this.style.color = this.textContent==='♥'?'#c0392b':'';
  });
});
